<template>
  <layout :session="session">
    <approvals :session="session" :approval-stats="profileApprovalStats"></approvals>

    <div class="mt-5 sm:mt-6 px-6 py-5 text-left max-w-2xl mx-auto">
      <p class="text-sm mb-2">
        Frage {{ currentQuestion }} von {{ questionsData.length }}
      </p>

      <div class="border-t border-gray-400 mt-4 mb-0"></div>

      <div class="flex flex-col mt-0">
        <div class="-my-2 py-2 overflow-x-auto sm:-mx-6 sm:px-6 lg:-mx-8 lg:px-8">
          <div class="align-middle inline-block overflow-hidden w-full">
            <table class="w-full border-separate border-spacing-y-2">
              <thead>
                <tr>
                  <th
                    class="w-1/12 px-2 sm:px-6 py-3 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider align-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="w-6 h-6 font-semibold mx-auto">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                    </svg>



                  </th>
                  <th
                    class="w-1/12 px-2 sm:px-6 py-3 text-center text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider align-bottom">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                      stroke="currentColor" class="w-6 h-6 font-semibold mx-auto">
                      <path stroke-linecap="round" stroke-linejoin="round" d="M5 12h14" />
                    </svg>
                  </th>

                  <th class="w-1/12 px-2 sm:px-6 py-3 align-bottom"></th>
                  <th class="px-2 sm:px-6 py-3 align-bottom"></th>
                  <th colspan="2" class="w-2/12 px-2 sm:px-6 py-3 align-bottom">
                    <ratings-total :session="session" :rating-stats="profileRatingStats" :ratings-view="ratingsView"
                      @ratingsViewToggled="onRatingsViewToggle"></ratings-total>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="option in profileOptions" :key="option.id"
                  class="rounded-md border focus:outline-none bg-white">
                  <td class="px-2 sm:px-6 text-center rounded-l-md relative">
                    <input :name="option.id" @change="select(option)" v-model="option.choice"
                      :disabled="option.choice == 'minus'" value="plus" type="radio"
                      class="form-radio h-6 w-6 text-markencode-green transition duration-150 ease-in-out focus:ring-0 focus:ring-offset-0 border-1 border-gray-300"
                      :class="option.choice == 'minus' ? 'opacity-50' : ''" />
                  </td>
                  <td class="px-2 sm:px-6 py-4 text-center">
                    <input :name="option.id" @change="select(option)" v-model="option.choice"
                      :disabled="option.choice == 'plus'" value="minus" type="radio"
                      class="form-radio h-6 w-6 text-markencode-red transition duration-150 ease-in-out focus:ring-0 focus:ring-offset-0 border-1 border-gray-300"
                      :class="option.choice == 'plus' ? 'opacity-50' : ''" />
                  </td>
                  <td
                    class="px-2 sm:px-6 py-4 whitespace-no-wrap text-md font-extralight text-gray-500 text-center border-l">
                    {{ enumerate(option) }}
                  </td>
                  <td
                    class="px-2 sm:px-6 py-4 whitespace-no-wrap text-md font-extralight leading-5 text-gray-500 text-left border-l">
                    <p v-html="formatTerms(option)"></p>
                  </td>
                  <td class="rounded-r-md border-l px-2">
                    <ratings :session="session" :option="option" :rating-stats="profileRatingStats"
                      :ratings-view="ratingsView" @ratingsViewToggled="onRatingsViewToggle"></ratings>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <button v-if="currentQuestion < questionsData.length" @click="gotoNextQuestion" :disabled="!validated"
        class="inline-flex justify-center w-full sm:w-min rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm focus:outline-none focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50"
        :class="!validated
      ? 'bg-gray-500 cursor-not-allowed'
      : 'bg-brandpreneurship-dark-gray hover:bg-black focus:border-black'
    ">
        WEITER
      </button>

      <button v-if="currentQuestion == questionsData.length" @click="complete" :disabled="!validated"
        class="inline-flex justify-center w-full sm:w-min rounded-md border border-transparent px-3 py-1.5 sm:my-2 sm:px-2 sm:py-2 text-base leading-6 font-medium text-white shadow-sm focus:outline-none focus:shadow-outline-red transition ease-in-out duration-150 sm:text-sm sm:leading-5 z-50 whitespace-nowrap"
        :class="!validated
      ? 'bg-gray-500 cursor-not-allowed'
      : 'bg-brandpreneurship-dark-gray hover:bg-black focus:border-black'
    ">
        {{ buttonText }}
      </button>
    </template>
  </layout>
</template>

<script>
import Layout from '@/Pages/ControlPanel/Shared/Layout';
import Approvals from '@/Pages/ControlPanel/Profile/Approvals';
import Ratings from '@/Pages/ControlPanel/Profile/Ratings';
import RatingsTotal from '@/Pages/ControlPanel/Profile/RatingsTotal';

export default {
  name: 'ProfileIndex',

  components: {
    Layout,
    Approvals,
    Ratings,
    RatingsTotal,
  },

  props: [
    'session',
    'phase',
    'currentPhaseId',
    'profileQuestions',
    'nextPhaseId',
    'step',
    'nextStep',
    'translations',
    'profileApprovalStats',
    'profileRatingStats',
  ],

  data() {
    return {
      currentQuestion: this.session.current_profile_question,
      questionsData: this.profileQuestions,
      ratingsView: 'absolute',
    };
  },

  methods: {
    enumerate(option) {
      let letters = ['A', 'B', 'C', 'D'];

      return `${letters[option.id - 1]}.`;
    },

    formatTerms(option) {
      let numComma = (option.terms.match(/,/g) || []).length;

      if (numComma == 1) {
        return option.terms.replace(',', ',<br />');
      }

      return option.terms;
    },

    onRatingsViewToggle(ratingsView) {
      this.ratingsView = ratingsView;
    },

    gotoNextQuestion() {
      // for now we make a reload when we switch to a new page.
      // Thus saving us some call to get rating stats etc.
      // this.currentQuestion = this.currentQuestion + 1;

      window.axios
        .post(
          this.route('control-panel.profile.next-question', {
            sessionUuid: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          window.location.reload();
        });
    },

    complete() {
      window.axios
        .post(
          this.route('control-panel.profile.complete', {
            sessionUuid: this.session.uuid,
          }),
          {}
        )
        .then((response) => {
          if (this.nextPhaseId) {
            this.$inertia.visit(
              this.route('control-panel.phase', {
                sessionUuid: this.session.uuid,
                phaseId: this.nextPhaseId,
              })
            );
          } else {
            this.$inertia.visit(
              this.route('control-panel.completed', {
                sessionUuid: this.session.uuid,
              })
            );
          }
        });
    },

    select(option) {
      this.questionsData[this.currentQuestion - 1].options.map((item) => {
        if (option.id != item.id && item.choice == option.choice) {
          this.$set(item, 'choice', '');
        }
      });

      // TODO: make this all nicer
      let plus = this.questionsData[this.currentQuestion - 1].options.filter(
        (item) => {
          return item.choice == 'plus';
        }
      );
      let minus = this.questionsData[this.currentQuestion - 1].options.filter(
        (item) => {
          return item.choice == 'minus';
        }
      );
      // console.log(plus[0].id);

      window.axios.post(
        this.route('control-panel.profile.store', {
          sessionUuid: this.session.uuid,
        }),
        {
          profile_question: this.currentQuestion,
          profile_question_plus: plus[0] !== undefined ? plus[0].id : '',
          profile_question_minus: minus[0] !== undefined ? minus[0].id : '',
        }
      );
    },
  },

  computed: {
    profileOptions() {
      return this.questionsData[this.currentQuestion - 1].options;
    },

    validated() {
      // TODO: make this all nicer
      let plus = this.questionsData[this.currentQuestion - 1].options.filter(
        (item) => {
          return item.choice == 'plus';
        }
      );
      let minus = this.questionsData[this.currentQuestion - 1].options.filter(
        (item) => {
          return item.choice == 'minus';
        }
      );

      if (plus[0] !== undefined && minus[0] !== undefined) {
        return true;
      }

      return false;
    },

    currentQuestionId() {
      return this.step;
    },

    nextQuestionId() {
      return this.nextStep.replace('question', '');
    },

    buttonText() {
      if (this.nextPhaseId) {
        return 'WEITER';
      }

      return 'FERTIG. ZUR STARTSEITE.';
    },
  },
};
</script>